import { useFormatMessage } from '../../../../../intl/intl';

export function useDialogLang({ orderId }: Props = {}) {
  const messageCategory = 'cargo';
  const messageCancelDialogSubcategory = 'cancelDialog';

  const cancelDialogTitleText = useFormatMessage({
    id: `${messageCategory}.${messageCancelDialogSubcategory}.title`,
  });

  const cancelDialogDescriptionText = useFormatMessage(
    { id: `${messageCategory}.${messageCancelDialogSubcategory}.description` },
    { orderId },
  );

  const cancelDialogDisclaimerText = useFormatMessage({
    id: `${messageCategory}.${messageCancelDialogSubcategory}.disclaimer`,
  });

  const cancelDialogBackButtonText = useFormatMessage({
    id: `${messageCategory}.${messageCancelDialogSubcategory}.backButton`,
  });

  const cancelDialogCancelOrderButtonText = useFormatMessage({
    id: `${messageCategory}.${messageCancelDialogSubcategory}.cancelOrderButton`,
  });

  const orderSuccessfullyCancelledTitleText = useFormatMessage({
    id: `${messageCategory}.${messageCancelDialogSubcategory}.orderSuccessfullyCancelledTitle`,
  });

  const orderSuccessfullyCancelledDescriptionText = useFormatMessage(
    {
      id: `${messageCategory}.${messageCancelDialogSubcategory}.orderSuccessfullyCancelledDescription`,
    },
    { orderId },
  );

  const orderRejectedCancelledTitleText = useFormatMessage({
    id: `${messageCategory}.${messageCancelDialogSubcategory}.orderRejectedCancelledTitle`,
  });

  const orderRejectedCancelledDescriptionText = useFormatMessage(
    {
      id: `${messageCategory}.${messageCancelDialogSubcategory}.orderRejectedCancelledDescription`,
    },
    { orderId },
  );

  return {
    cancelDialogTitleText,
    cancelDialogDescriptionText,
    cancelDialogDisclaimerText,
    cancelDialogBackButtonText,
    cancelDialogCancelOrderButtonText,
    orderSuccessfullyCancelledTitleText,
    orderSuccessfullyCancelledDescriptionText,
    orderRejectedCancelledTitleText,
    orderRejectedCancelledDescriptionText,
  };
}

interface Props {
  orderId?: number;
}
